<template>
  <details v-if="taxe.length" class="taxe" :class="`taxe-${culoare}`" :open="deschis" @toggle="deschis = $event.target.open">
    <summary :aria-label="`Taxe ${titlu} ${inventar}: ${principala.tip_taxa}, ${termen(principala)}`">
      <strong class="taxe-titlu">{{ titlu }}</strong>
      <span v-if="inventar" class="taxe-inv">{{ inventar }}</span>
      <span class="taxe-rez">{{ principala.tip_taxa }} · {{ termen(principala) }}</span>
      <span class="taxe-nr" :aria-label="`${taxe.length} taxe`">{{ taxe.length }}</span>
      <span class="taxe-sageata" aria-hidden="true">
        <svg viewBox="0 0 24 24" width="20" height="20"><path d="M5 9l7 7 7-7" fill="none" stroke="currentColor" stroke-width="3.2" stroke-linecap="round" stroke-linejoin="round" /></svg>
      </span>
    </summary>
    <ul>
      <li v-for="taxa in taxe" :key="taxa.cod_taxa">
        <i class="punct" :class="`punct-${culoareTaxa(taxa)}`" aria-hidden="true"></i>
        <span class="taxe-nume">{{ taxa.tip_taxa }}</span>
        <span class="taxe-termen" :class="{ 'taxe-termen-rosu': culoareTaxa(taxa) === 'rosu' }">{{ termen(taxa) }}</span>
        <time :datetime="taxa.data_expirare">{{ dataExpirare(taxa.data_expirare) }}</time>
      </li>
    </ul>
  </details>
</template>
<script>
export default {
  name: 'TaxeUtilaj',
  props: {
    taxe: { type: Array, default: () => [] },
    titlu: { type: String, default: '' },
    inventar: { type: String, default: '' },
    // Deschisă automat (ex. imediat după pornirea FC/FAZ-ului); altfel pornește închisă.
    deschisaInitial: { type: Boolean, default: false },
  },
  data() {
    return { deschis: this.deschisaInitial };
  },
  watch: {
    deschisaInitial(valoare) {
      if (valoare) this.deschis = true;
    },
  },
  computed: {
    culoare() {
      if (this.taxe.some(taxa => this.culoareTaxa(taxa) === 'rosu')) return 'rosu';
      if (this.taxe.some(taxa => this.culoareTaxa(taxa) === 'portocaliu')) return 'portocaliu';
      return 'verde';
    },
    // Lista vine sortată după zilele rămase: prima e cea mai urgentă.
    principala() {
      return this.taxe[0];
    },
  },
  methods: {
    culoareTaxa(taxa) {
      if (taxa.zile_ramase <= 7) return 'rosu';
      return taxa.zile_ramase <= 30 ? 'portocaliu' : 'verde';
    },
    dataExpirare(data) {
      return data.split('-').reverse().join('.');
    },
    termen(taxa) {
      const zile = taxa.zile_ramase;
      const unitate = Math.abs(zile) === 1 ? 'zi' : 'zile';
      if (zile < 0) return `expirat de ${-zile} ${unitate}`;
      if (zile === 0) return 'expiră azi';
      return `${zile} ${unitate}`;
    },
  },
};
</script>
<style scoped>
.taxe {
  margin-bottom: 0.3rem;
  border-radius: 0.4rem;
  overflow: hidden;
  font-size: 0.8rem;
  text-align: left;
}
.taxe summary {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  min-height: 38px;
  padding: 0.2rem 0.35rem 0.2rem 0.6rem;
  color: #fff;
  cursor: pointer;
  list-style: none;
}
.taxe summary::-webkit-details-marker {
  display: none;
}
/* Săgeata trebuie să se vadă de la prima privire: buton rotund alb, nu un caracter mic. */
.taxe-sageata {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.35);
  transition: transform 0.2s ease;
}
.taxe-rosu .taxe-sageata {
  color: #bb2331;
}
.taxe-portocaliu .taxe-sageata {
  color: #a34b00;
}
.taxe-verde .taxe-sageata {
  color: #146c43;
}
.taxe[open] .taxe-sageata {
  transform: rotate(180deg);
}
.taxe summary:focus-visible {
  outline: 3px solid #fff;
  outline-offset: -4px;
}
.taxe-rosu summary {
  background: #bb2331;
}
.taxe-portocaliu summary {
  background: #a34b00;
}
.taxe-verde summary {
  background: #146c43;
}
.taxe-titlu,
.taxe-inv {
  flex-shrink: 0;
}
.taxe-inv {
  opacity: 0.85;
}
.taxe-rez {
  flex: 1;
  min-width: 0;
  text-align: right;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.taxe-nr {
  flex-shrink: 0;
  padding: 0 0.35rem;
  border-radius: 1rem;
  background: #fff;
  color: #212529;
  font-size: 0.7rem;
  font-weight: bold;
}
.taxe ul {
  margin: 0;
  padding: 0 0.6rem;
  list-style: none;
  border: 1px solid rgba(128, 128, 128, 0.3);
  border-top: 0;
  border-radius: 0 0 0.4rem 0.4rem;
}
.taxe li {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  min-height: 28px;
}
.taxe li + li {
  border-top: 1px solid rgba(128, 128, 128, 0.2);
}
.taxe-nume {
  font-weight: 600;
}
.taxe-termen {
  flex: 1;
  color: #6c757d;
}
.taxe-termen-rosu {
  color: #bb2331;
  font-weight: 600;
}
.punct {
  flex-shrink: 0;
  width: 0.55rem;
  height: 0.55rem;
  border-radius: 50%;
}
.punct-rosu {
  background: #bb2331;
}
.punct-portocaliu {
  background: #f0ad4e;
}
.punct-verde {
  background: #146c43;
}
</style>
